import { InferOutput, number, pipe, safeInteger } from 'valibot'

// const { isSafeInteger } = Number

// export const SafeIntegerSchema = pipe(number(), check((v) => isSafeInteger(v)))
export const SafeIntegerSchema = pipe(number(), safeInteger())

export type SafeInteger = InferOutput<typeof SafeIntegerSchema>
